module.exports = " <div class=volume-button ng-if=$ctrl.AudioManager.isMuted hm-tap=\"$ctrl.AudioManager.toggleSound(); $ctrl.AudioManager.playFx('muteButton')\"> <div class=icon-muted> <img ng-src={{$ctrl.AppServices.DataManager.config.settings.assetsPath}}icons/BTN_SOUND_OFF-11.png alt=\"\"/> </div> </div> <div class=volume-button ng-if=!$ctrl.AudioManager.isMuted hm-tap=\"$ctrl.AudioManager.toggleSound(); $ctrl.AudioManager.playFx('muteButton')\"> <div class=icon-unmuted> <img ng-src={{$ctrl.AppServices.DataManager.config.settings.assetsPath}}icons/BTN_SOUND_ON-11.png alt=\"\"/> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/volume-button/volume-button.html
 ** module id = 71
 ** module chunks = 0
 **/